module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "vw-steps"
  }, [_vm._l((_vm.steps), function(step, i) {
    return [_c('div', {
      class: [{
        'vw-steps-processing': i === _vm.processing,
        'vw-steps-done': i < _vm.processing
      }, 'vw-steps-item']
    }, [_c('i', {
      staticClass: "weui-icon-success vw-steps-item-icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "vw-steps-item-num"
    }, [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('div', {
      staticClass: "vw-steps-item-desc"
    }, [_vm._v(_vm._s(step))])]), _vm._v(" "), (i !== _vm.steps.length - 1) ? _c('div', {
      class: [{
        'active': i < _vm.processing
      }, 'vw-steps-item__connect'],
      style: (_vm.lineWidth)
    }) : _vm._e()]
  })], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-75ddfea9!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/step.vue
// module id = 266
// module chunks = 0